import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateUsername } from '../../Api/authApi.js.js';
import { updateUser } from '../../redux/authSlice.js';
import { toast } from 'react-toastify';
import './updateuser.css';

const UpdateUser = () => {
    const [username, setUsername] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.auth.user);

    const handleUpdate = async () => {
        if (!username.trim()) {
            toast.warning("Le nom d'utilisateur est requis.");
            return;
        }
        try {
            const data = await updateUsername(user.id, username.trim());
            toast.success(data.message);
            dispatch(updateUser({ username: username.trim() }));
            navigate('/profil');
        } catch (error) {
            toast.warning(error.message);
        }
    };

    return (
        <div className="settings-form-page">
            <div className="sfp-header">
                <button className="sfp-back-btn pill-tap" onClick={() => navigate('/profil')}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <span className="sfp-page-title">Modifier le pseudo</span>
            </div>

            <div className="sfp-body">
                <p className="sfp-subtitle">Choisis un nouveau nom d'utilisateur</p>

                <div className="sfp-card relief">
                    <div className="sfp-field">
                        <span className="sfp-field-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                <path fillRule="evenodd" d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z" clipRule="evenodd"/>
                            </svg>
                        </span>
                        <input
                            className="sfp-input"
                            type="text"
                            name="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Nouveau pseudo"
                            autoComplete="username"
                            onKeyDown={(e) => e.key === 'Enter' && handleUpdate()}
                        />
                    </div>

                    <button className="sfp-submit pill-tap" onClick={handleUpdate}>
                        Confirmer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpdateUser;
